import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, delay } from 'rxjs';
import { PensionContributionsResponse } from './pension-contribution-employee.model';
import { environment } from '@env/environment';

@Injectable()
export class PensionContributionsDataProvider {
  protected apiRoot = `${environment.apiPaths.pensions}`;

  constructor(private http: HttpClient) {}

  getSubmissionContributions$(submissionId: number): Observable<PensionContributionsResponse> {
    // TODO: Replace with actual API call once backend is ready

    return of(this.getMockData(submissionId)).pipe(delay(500));
  }

  private getMockData(submissionId: number): PensionContributionsResponse {
    return {
      submissionId,
      payrollName: 'Main Payroll',
      providerName: 'Aviva',
      periodStart: '2025-10-01',
      periodEnd: '2025-10-31',
      contributions: [
        {
          employeeId: 'EMP001',
          employeeName: 'John Smith',
          errorDescription: 'Missing NI number',
          periodEarnings: 2500.0,
          employeeContribution: 125.0,
          employerContribution: 75.0,
          total: 200.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: undefined
        },
        {
          employeeId: 'EMP002',
          employeeName: 'Jane Doe',
          errorDescription: undefined,
          periodEarnings: 3200.0,
          employeeContribution: 160.0,
          employerContribution: 96.0,
          total: 256.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: undefined
        },
        {
          employeeId: 'EMP003',
          employeeName: 'Bob Johnson',
          errorDescription: undefined,
          periodEarnings: 2800.0,
          employeeContribution: 140.0,
          employerContribution: 84.0,
          total: 224.0,
          pensionGroup: 'Group B',
          zeroContributionsReason: undefined
        },
        {
          employeeId: 'EMP004',
          employeeName: 'Alice Williams',
          errorDescription: 'Below earnings threshold',
          periodEarnings: 500.0,
          employeeContribution: 0.0,
          employerContribution: 0.0,
          total: 0.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: 'Below auto-enrolment threshold'
        },
        {
          employeeId: 'EMP005',
          employeeName: 'Charlie Brown',
          errorDescription: undefined,
          periodEarnings: 4500.0,
          employeeContribution: 225.0,
          employerContribution: 135.0,
          total: 360.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: undefined
        }
      ]
    };
  }
}
